import { captureException } from '@sentry/nextjs'

import { isEnvelopErrorWithStatus } from '@/types/api-helpers'

import fetchRequest from '@/app/_utils/fetch-request'
import { IS_ON_SERVER } from '@/app/_utils/select-api-service'
import { ServiceName } from '@/app/_utils/types'

import { PLPPages, PLPSlug } from '../types'

export async function getPLPBasicMetas(page: PLPPages, slug: PLPSlug, isServerSideRequest = false) {
    let serviceName: ServiceName = 'cml'
    let endpoint = ''

    if (page === PLPPages.Tags) {
        endpoint = `/tags/slug/${slug}`
    } else if (page === PLPPages.Facets) {
        endpoint = `/combinations/slug/${slug}`
    } else if (page === PLPPages.BrandCategoriesCombination) {
        endpoint = `/combinations/type/CategoryBrand/slug/${slug}`
    } else {
        serviceName = 'ntl'
        endpoint = `/catalog/${page}/slug/${slug}`
    }

    try {
        const result = await fetchRequest({
            endpoint,
            serviceName,
            appendCurrentQueryStrings: true,
            isServerSideRequest: IS_ON_SERVER && isServerSideRequest,
        })

        return result
    } catch (error) {
        const errorEnvelop = Array.isArray(error) ? error.at(0) : null
        const typedErrorEnvelop = isEnvelopErrorWithStatus(errorEnvelop) ? errorEnvelop : null

        if (
            typedErrorEnvelop?.status === 404 ||
            typedErrorEnvelop?.code === 'record.not.found' ||
            typedErrorEnvelop?.code === 'invalid.input' ||
            typedErrorEnvelop?.code === 'invalid.slug' ||
            typedErrorEnvelop?.code === 'entity.not.found'
        )
            return null

        const errorMessage = `[error-fetching-basic-metas]. ServiceName: ${serviceName}, Endpoint: ${endpoint} - ${error}`
        captureException(errorMessage)
        throw new Error(errorMessage)
    }
}
